// extracted by mini-css-extract-plugin
export default {"container":"waiting-for-files_container__MbREf","greenButton":"waiting-for-files_greenButton__FTLuK"};